// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__8vpwU","activeLink":"NavBar_activeLink__xfU4h"};